import {ChatPersonaType} from "../../toktiv-common/types";
import {ChatMessage, ParticipantKey} from "../shared/messages/chat/types";
import {ChatContent, ChatResponse} from "../../toktiv-common/api/types";
import {Agent} from "../Agent";
import {getCloudHostForEnvironment} from "../../toktiv-common/consts";

export class ChatAgent extends Agent {

  constructor(readonly myParticipantKey: ParticipantKey) {
    super();
  }

  async chat(personaType: ChatPersonaType, messages: ChatMessage[]): Promise<string> {
    let maxUserHistory = 2;
    let lastUserMessageIndex = messages.length;
    for (let i = messages.length - 1; i >= 0; i--) {
      if (messages[i].from.id === this.myParticipantKey.id) {
        lastUserMessageIndex = i;
        if (--maxUserHistory <= 0) {
          break;
        }
      }
    }
    const response = await fetch(getCloudHostForEnvironment(this.env) + "/api/chat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        persona: personaType,
        history: messages.slice(lastUserMessageIndex).map(message => {
          return {
            role: message.from.id === personaType ? "assistant" : "user",
            text: message.text,
          } as ChatContent;
        }),
      })
    }).then(res => res.json()) as ChatResponse;
    if (response.status.code !== 200) {
      throw new Error("Error fetching chat");
    }
    return response.response.content.text;
  }
}